import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../routes'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        API: "https://api.goldenshamela.com/api",
        token: localStorage.getItem('token') || null,
        lang : localStorage.getItem('lang') || 'ar',
        name: localStorage.getItem('name') || null,
        Msg: {
            text: '',
            color: '',
            snackbar: false,
        },
        loading: false,
    },
    getters: {
        getAPI(state) {
            return state.API
        },
        getLang(state) {
            return state.lang
        },
        loggedIn(state) {
            return state.token !== null
        },
        getName(state) {
            return state.name
        },
        getAuthHeader(state) {
            const config = {
                headers: {
                    Authorization: "Bearer " + state.token,
                }
            };
            return config
        },
        getMsg(state) {
            return state.Msg;
        },
        getLoading(state) {
            return state.loading;
        }
    },
    mutations: {
        SetToken(state, data) {
            state.token = data.token;
            state.name = data.User.firstname + ' ' + data.User.lastname
        },
        SetLang(state) {
            state.lang = localStorage.getItem('lang') || 'ar'
        },
        destroyToken(state) {
            state.token = null;
            state.name = null;
        },
        PushMsg(state, Msg) {
            state.Msg.snackbar = true;
            state.Msg.text = Msg.text;
            state.Msg.color = Msg.color;
        },
        RevertLoading(state) {
            state.loading = !state.loading;
        },
    },
    actions: {
        PushSuccessMsg(context, text) {
            let Msg = {};
            Msg.snackbar = true;
            Msg.text = text;
            Msg.color = 'success';
            context.commit('PushMsg', Msg)
        },
        PushErrorMsg(context, text) {
            let Msg = {};
            Msg.snackbar = true;
            Msg.text = text;
            Msg.color = 'red';
            context.commit('PushMsg', Msg)
        },
        GetFromAPI(context, api) {
            return new Promise((resolve, reject) => {
                context.commit('RevertLoading');
                axios.get(context.getters.getAPI + api, context.getters.getAuthHeader)
                    .then(response => {
                        context.commit('RevertLoading');
                        resolve(response);
                    })
                    .catch(error => {
                        context.commit('RevertLoading');
                        reject(error.response);
                    });
            });
        },
        PostToAPI(context, DataForm) {
            return new Promise((resolve, reject) => {
                context.commit('RevertLoading');
                axios.post(context.getters.getAPI + DataForm.API , DataForm.Param , context.getters.getAuthHeader)
                    .then(response => {
                        context.commit('RevertLoading');
                        resolve(response);
                    })
                    .catch(error => {
                        context.commit('RevertLoading');
                        reject(error.response);
                    });
            });
        },
        PutToAPI(context, DataForm) {
            return new Promise((resolve, reject) => {
                context.commit('RevertLoading');
                axios.put(context.getters.getAPI + DataForm.API , DataForm.Param , context.getters.getAuthHeader)
                    .then(response => {
                        context.commit('RevertLoading');
                        resolve(response);
                    })
                    .catch(error => {
                        context.commit('RevertLoading');
                        reject(error.response);
                    });
            });
        },
        DeleteToAPI(context, Api) {
            return new Promise((resolve, reject) => {
                context.commit('RevertLoading');
                axios.delete(context.getters.getAPI + Api , context.getters.getAuthHeader)
                    .then(response => {
                        context.commit('RevertLoading');
                        resolve(response);
                    })
                    .catch(error => {
                        context.commit('RevertLoading');
                        reject(error.response);
                    });
            });
        }


    },
    modules: {}
})
axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    if (error.response.status === 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('name')
        router.push({ name: 'Login' })
    }
    return Promise.reject(error)
  })